// See more @ https://github.com/laravel/echo

import Echo from 'laravel-echo'
import Pusher from 'pusher-js'

declare global {
    interface Window {
        Pusher: typeof Pusher
        Echo: InstanceType<typeof Echo>
    }
}

class EchoVendor {
    static init: () => void = () => {
        if (!window.shared.auth.id) {
            return
        }

        window.Pusher = Pusher
        const options = {
            broadcaster: 'pusher',
            key: window.shared.pusher.key,
            wsHost: window.shared.pusher.host,
            wssHost: window.shared.pusher.host,
            wsPort: window.shared.pusher.port,
            wssPort: window.shared.pusher.port,
            cluster: window.shared.pusher.cluster,
            forceTLS: window.shared.pusher.force_tls,
        }
        // @ts-ignore
        window.Echo = new Echo(options)
    }
}

export default EchoVendor
